"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const button_1 = __importDefault(require("./button"));
const textfield_1 = __importDefault(require("./textfield"));
const tooltip_1 = __importDefault(require("./tooltip"));
const link_1 = __importDefault(require("./link"));
const togglebutton_1 = __importDefault(require("./togglebutton"));
const slider_1 = __importDefault(require("./slider"));
const progress_1 = __importDefault(require("./progress"));
const overrides = theme => styles_1.createMuiTheme(theme, {
    overrides: {
        ...button_1.default(theme),
        ...tooltip_1.default(theme),
        ...textfield_1.default(theme),
        ...link_1.default(theme),
        ...togglebutton_1.default(theme),
        ...slider_1.default(theme),
        ...progress_1.default(theme),
    },
});
exports.default = overrides;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvb3ZlcnJpZGVzL2luZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEscURBQTBEO0FBRTFELHNEQUE4QjtBQUM5Qiw0REFBb0M7QUFDcEMsd0RBQWdDO0FBQ2hDLGtEQUEwQjtBQUMxQixrRUFBMEM7QUFDMUMsc0RBQThCO0FBQzlCLDBEQUFrQztBQUVsQyxNQUFNLFNBQVMsR0FBRyxLQUFLLENBQUMsRUFBRSxDQUN4Qix1QkFBYyxDQUFDLEtBQUssRUFBRTtJQUNwQixTQUFTLEVBQUU7UUFDVCxHQUFHLGdCQUFNLENBQUMsS0FBSyxDQUFDO1FBQ2hCLEdBQUcsaUJBQU8sQ0FBQyxLQUFLLENBQUM7UUFDakIsR0FBRyxtQkFBUyxDQUFDLEtBQUssQ0FBQztRQUNuQixHQUFHLGNBQUksQ0FBQyxLQUFLLENBQUM7UUFDZCxHQUFHLHNCQUFZLENBQUMsS0FBSyxDQUFDO1FBQ3RCLEdBQUcsZ0JBQU0sQ0FBQyxLQUFLLENBQUM7UUFDaEIsR0FBRyxrQkFBUSxDQUFDLEtBQUssQ0FBQztLQUNuQjtDQUNGLENBQUMsQ0FBQztBQUVMLGtCQUFlLFNBQVMsQ0FBQyJ9